const Storage = require('utilities/storage');

function timeStamp() {
    return next => action => {
        Storage.cookies.set('lastTimeStamp', Date.now());
        return next(action);
    };
}

module.exports = timeStamp;
